/**
 * @generated SignedSource<<0788255f2258432bb3a906ab7a47a259>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type FeatureKind = "EXPERIMENT" | "OPS" | "RELEASE" | "%future added value";
export type experimentsQuery$variables = Record<PropertyKey, never>;
export type experimentsQuery$data = {
  readonly experiments: ReadonlyArray<{
    readonly assignments: ReadonlyArray<{
      readonly assignedUtc: any;
      readonly firstExposedUtc: any | null | undefined;
      readonly variant: string;
      readonly vaultId: any;
    }>;
    readonly flagKey: FeatureKey;
    readonly key: string;
    readonly variants: ReadonlyArray<{
      readonly name: string;
      readonly weight: number;
    }>;
  }>;
  readonly featureFlags: ReadonlyArray<{
    readonly key: FeatureKey;
    readonly kind: FeatureKind;
  }>;
};
export type experimentsQuery = {
  response: experimentsQuery$data;
  variables: experimentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ExperimentWithAssignmentsState",
    "kind": "LinkedField",
    "name": "experiments",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flagKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ExperimentVariantState",
        "kind": "LinkedField",
        "name": "variants",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ExperimentAssignmentState",
        "kind": "LinkedField",
        "name": "assignments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "variant",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedUtc",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstExposedUtc",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "FeatureFlagState",
    "kind": "LinkedField",
    "name": "featureFlags",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "experimentsQuery",
    "selections": (v1/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "experimentsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "086878054bc67b9c01306c2778411073",
    "id": null,
    "metadata": {},
    "name": "experimentsQuery",
    "operationKind": "query",
    "text": "query experimentsQuery {\n  experiments {\n    key\n    flagKey\n    variants {\n      name\n      weight\n    }\n    assignments {\n      vaultId\n      variant\n      assignedUtc\n      firstExposedUtc\n    }\n  }\n  featureFlags {\n    key\n    kind\n  }\n}\n"
  }
};
})();

(node as any).hash = "5691b4265d6415df7f4ad5731a5b4fbc";

export default node;
